module.exports = __webpack_public_path__ + "img/validation-cam.009c5e1d.svg";